import extension from './extension.json';
import profiles from './profiles.json';
import website from './website.json';

export default {
  extension,
  profiles,
  website
};
